// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"636":"87301bb4","914":"d8c871a0"}[chunkId] + ".chunk.css";
};